import Cookie from 'js-cookie'

export const AuthVerificationMixin = {
  data () {
    return {
      smallTable: true,
      variants: ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'dark']
    }
  },
  created () {
    this.checkCurrentLogin()
    this.user = localStorage.username
  },
  methods: {
    reloadWindow () {
      var tnow = Math.round((new Date()).getTime() / 1000)
      if (Object.keys(localStorage).includes('lastServiceUpdate')) {
        if (tnow - localStorage['lastServiceUpdate'] >= 30) {
          localStorage['lastServiceUpdate'] = tnow
          window.location.reload(true)
        }
      } else {
        localStorage['lastServiceUpdate'] = tnow
        window.location.reload(true)
      }
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time))
    },
    checkCurrentLogin () {
      Cookie.remove('access_token')
      if (localStorage.refreshToken && localStorage.accessToken && localStorage.username) {
        if (localStorage.accessTime && (Date.now() / 1000 - localStorage.accessTime >= 1200)) {
          this.refreshToken()
        } else {
          var url = this.baseUrl + 'auth/verify/'
          var authHeaders = {'Authorization': localStorage.accessToken}

          this.$http.get(url, {headers: authHeaders})
            .then(user => {
            }, user => {
              console.error('tried ... but ... authentication did not work')
              this.$router.replace(this.$route.query.redirect || '/frb-web/login')
            })
        }
      } else {
        this.$router.replace(this.$route.query.redirect || '/frb-web/login')
      }
    },
    refreshToken () {
      Cookie.remove('access_token')
      if (localStorage.refreshToken && localStorage.accessToken && localStorage.username) {
        var url = this.baseUrl + 'auth/refresh'
        var authHeaders = {'Authorization': localStorage.accessToken}
        // var authHeaders = {'Authorization': localStorage.accessToken}
        var refreshPayload = {'refresh_token': localStorage.refreshToken}
        this.$http.post(url, refreshPayload, {headers: authHeaders})
          .then(user => {
            console.log('access token refreshed')
            localStorage.accessToken = user.body.access_token
            localStorage.accessTime = Date.now() / 1000
          }, user => {
            this.$router.replace(this.$route.query.redirect || '/frb-web/login')
          })
      } else {
        this.$router.replace(this.$route.query.redirect || '/frb-web/login')
      }
    },
    waitForIt (waitTime) {
      // Create a new Promise and resolve after 2 seconds
      var waitPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, waitTime)
      })
      return waitPromise
    },
    waitBeforeExecution (waitTime) {
      if (Date.now() / 2000 - localStorage.accessTime >= 1200) {
        this.refreshToken()
        waitTime = this.waitForIt(1000)
      }
      return waitTime
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/auth_mixin.js